import { isAuthorized } from '../../../../../FSM/shared/guards'

export default { isAuthorized }
